import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "#000",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }, [
      _createElementVNode("path", { d: "m15 3-4 6h8Z" }),
      _createElementVNode("circle", {
        cx: "15",
        cy: "20",
        r: "7"
      }),
      _createElementVNode("path", { d: "m15 16.5 1.2 2.4 2.6.2-1.9 1.8.5 2.4L15 22l-2.4 1.3.5-2.4-1.9-1.8 2.6-.2Z" })
    ], -1 /* CACHED */)
  ]))]))
}
export default { render: render }